import ticketinhotelSignIn from 'img/themes/ticketinhotel-sing-in-logo'
import ticketforcitySignIn from 'img/themes/ticketforcity-sing-in-logo'
import ticketInSignIn from 'img/themes/ticket-in-sing-in-logo'

const themes = [
  {
    code: 'ticketinhotel',
    name: 'Ticketinhotel',
    brand_logo_url: null,
    sing_in_logo: ticketinhotelSignIn
  },
  {
    code: 'ticketforcity',
    name: 'Ticketforcity',
    brand_logo_url: null,
    sing_in_logo: ticketforcitySignIn
  },
  {
    code: 'ticket-in',
    name: 'TicketIn',
    brand_logo_url: null,
    sing_in_logo: ticketInSignIn
  },  
  {
    code: 'localhost',
    name: 'Localhost',
    brand_logo_url: null,
    sing_in_logo: ticketinhotelSignIn
  },
  {
    code: 'default',
    name: 'Ticketinhotel',
    brand_logo_url: null,
    sing_in_logo: ticketinhotelSignIn
  }
]

const themeBydomain = () => {
  return themes.find((t) => window.location.hostname.includes(t.code) || t.code == 'default')
}

export default themes
export {themeBydomain}
